<!--
* @Name：工程类认定申请审批供应商信息-评审结果列表
* @Author: 王超
* @Date: 2024-12-16
-->
<template>
  <div class="component-overlay">
    <van-nav-bar title="评审结论列表" left-arrow left-text="返回" @click-left="close" :fixed="true" />
    <div class="component-container">
      <hi-card v-for="(item, index) in lineList" :key="item.suppId" :row-index="index + 1">
        <van-row>
          <span>评审人：</span>
          <span>{{ item.reviewerName }}</span>
        </van-row>
        <van-row>
          <span>评审结论：</span>
          <span>{{ item.conclusion === '1' ? '同意' : item.conclusion === '0' ? '不同意' : '' }}</span>
        </van-row>
        <van-row>
          <span>结论说明：</span>
          <span>{{ item.conclusionDesc }}</span>
        </van-row>
        <van-row>
          <span>评审时间：</span>
          <span>{{ item.reviewTime }}</span>
        </van-row>
      </hi-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'qualifyApplyDetail',
  data() {
    return {
      showPopup: false // 控件是否显示
    }
  },
  props: {
    // 弹框是否显示
    detailsVisible: {
      type: Boolean
    },
    // 评审结果列表
    lineList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    close() {
      this.$emit('close-details-dialog')
    }
  }
}
</script>
